import { StateCreator } from "zustand";
import { screen as rudderTrackScreen } from "@utils/rudderstack";
import { AppState } from "react-native";
import { NavigationState, PathnameState } from "../types";

const MAX_HISTORY_SIZE = 10;

export const createPathnameSlice: StateCreator<
  NavigationState,
  [],
  [],
  PathnameState
> = (set) => ({
  currentPath: "/",
  previousPath: "/",
  pathHistory: ["/"],
  isLoginPath: false,
  isSetPasswordPath: false,
  isStorePath: false,
  isLibraryPath: false,
  isInboxPath: false,
  onPathnameChange: (path: string) =>
    set((state) => {
      if (path !== state.currentPath) {
        console.log(`[Nav] ${state.currentPath} → ${path}`);
        rudderTrackScreen(path);
        // Log access-related pathname changes for deep link debugging
        if (path.includes("/access/") || state.currentPath.includes("/access/")) {
          console.log("::pathnameSlice:: access route change", {
            from: state.currentPath,
            to: path,
            appState: AppState.currentState,
          });
        }
      }

      // Update history by adding current path, keeping only last MAX_HISTORY_SIZE entries
      const newHistory = [...state.pathHistory, state.currentPath].slice(
        -MAX_HISTORY_SIZE,
      );

      return {
        previousPath: state.currentPath,
        currentPath: path,
        pathHistory: newHistory,
        isLoginPath: path.includes("/login"),
        isSetPasswordPath:
          path.includes("/set-password") ||
          path.includes("/auth/reset-password"),
        isStorePath: path.includes("/store"),
        isLibraryPath: path.includes("/library"),
        isInboxPath: path.includes("/inbox"),
      };
    }),
});
